export const countryOptions = [
    { value: "usPuerto", label: "United States and Puerto Rico" },
    { value: "colombia", label: "Colombia" },
    { value: "dominicanRepublic", label: "Dominican Republic" },
    { value: "japan", label: "Japan" },
    { value: "venezuela", label: "Venezuela" },
    { value: "other", label: "Other" },
];
